import { parseProducer, parseProducers } from 'utils/producers'
import { Language } from 'types/language'
import { Producer } from 'types/producer'
import request, { getAxiosRequestConfig } from 'utils/request'

/**
 * Fetches the producers from the API
 *
 * @param language
 * @returns Promise<Producer[]>
 */
export const fetchProducers = async (language: Language): Promise<Producer[]> => {
  const { success, data } = await request(getAxiosRequestConfig('GET', 'producers'))

  return success ? parseProducers(data, language) : []
}

/**
 * Fetches the producer by slug
 *
 * @param string slug
 * @returns Promise<Producer>
 */
export const fetchProducerBySlug = async (slug: string): Promise<Producer> => {
  const { success, data } = await request(getAxiosRequestConfig('GET', `producers/slug/${slug}`))

  return success ? parseProducer(data) : null
}

/**
 * Fetches the producer for customer by customer email
 *
 * @param string email
 * @returns Promise<Producer>
 */
export const fetchProducerForCustomer = async (email: string): Promise<Producer> => {
  const { success, data } = await request(getAxiosRequestConfig('GET', `producer/customer?email=${email}`))

  return success ? parseProducer(data) : null
}

/**
 * Sends the producer request to the API
 *
 * @param data
 * @returns
 */
export const producerRequest = async (data): Promise<boolean> => {
  const { success } = await request(getAxiosRequestConfig('POST', 'producers/request', data))

  return success
}
